const Menu = [
  { path: "public/Inbox", icon: "fa fa-envelope", badge: null, title: "Inbox" },
  {
    path: "public/Archived",
    icon: "fa fa-archive",
    badge: null,
    title: "Archived",
  },
  {
    path: "public/Draft",
    icon: "fa fa-pencil-square",
    badge: null,
    title: "Drafts",
  },
  {
    path: "public/WriteMessage",
    icon: "fa fa-file-text",
    title: "WriteMessage",
  },
  { path: "public/SentPhotos", icon: "fa fa-paper-plane", title: "sendphotos" },
  {
    path: "public/SentE-Cards",
    icon: "fa fa-birthday-cake",
    title: "EcardHistory",
  },
  { path: "public/FindInmates", icon: "fa fa-search", title: "FindInmates" },
  {
    path: "public/Mycontacts",
    icon: "fa fa-address-book",
    title: "MyContacts",
  },
  { path: "public/MyAccount", icon: "fa fa-user", title: "MyAccount" },
  //  { path: "public/VideoCall", icon: "fa fa-video", title: "Visitation" },
  {
    path: "public/PurchaseCredits",
    icon: "fa fa-shopping-cart",
    title: "PurchaseCredits",
  },
  { path: "public/Support", icon: "fa-solid fa-headset", title: "Support" },
  { path: "#", icon: "fa fa-sign-out", title: "Logout" },
];

export default Menu;
